export const mintGreen = "#B8E4C0";
export const darkGreen = "#336b46";
// export const darkGreen = "#6ABF86";
export const darkOrange = "#FBA536";
export const lightOrange = "#F9BB6A";
export const lightBrown = "#E69F66";
export const lightBeige = "#f5f3ef";
export const brightOrange = "#FEEFCC";
// export const lightBeige = "#f2ede4";
